import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Primary } from '../../../assets/Colors';
import BooksIcon from '../../../assets/adminIcons/book-stack.png';
import Logs from '../../../assets/adminIcons/bug.png';
import Corporate from '../../../assets/adminIcons/business.png';
import Cache from '../../../assets/adminIcons/data.png';
import ContentManagment from '../../../assets/adminIcons/digital-asset.png';
import ProductAssignment from '../../../assets/adminIcons/direct-marketing.png';
import Feedback from '../../../assets/adminIcons/feedback.png';
import CMS from '../../../assets/adminIcons/folder.png';
import Members from '../../../assets/adminIcons/group.png';
import Coaching from '../../../assets/adminIcons/leadership.png';
import WorkList from '../../../assets/adminIcons/list.png';
import OnlineLecture from '../../../assets/adminIcons/online-content.png';
import VideoSolution from '../../../assets/adminIcons/podcast.png';
import Credit from '../../../assets/adminIcons/salary.png';
import TopicSelection from '../../../assets/adminIcons/task-list.png';
import AchivementSelection from '../../../assets/adminIcons/task-list.png';
import KPSSComp from '../../../assets/adminIcons/task.png';
import CMSApprove from '../../../assets/adminIcons/validation.png';
import Analytics from '../../../assets/adminIcons/analytics.png';
import { getAllUsers } from '../../../api/User';
import { getAllBooks } from '../../../api/Book';
import { GetAllCoaches } from '../../../api/AdminCoachPanel/coachApis';
import { getReports } from '../../../api/FeedBacks';
import SideBar from '../../../components/SideBar';
import { Components } from '../../../assets/Dimensions';
import { setSelectedItem } from '../../../redux/actions/sidebarAction';

const AdminDashboard = ({ setSelectedItem }) => {
    const history = useHistory();
    const User = JSON.parse(localStorage.getItem('user'));
    
    const [stats, setStats] = useState({
        totalUsers: 0,
        totalBooks: 0,
        totalCoaches: 0,
        totalFeedbacks: 0
    });

    useEffect(() => {
        setSelectedItem('');
        const fetchStats = async () => {
             if (User && User.Token) {
                try {
                    // Fetch Users Count
                    // Matching MembersPage.js pattern
                    const usersRes = await getAllUsers({
    "PageSize": 6,
    "PageNumber": 0,
    "SearchValue": "",
    "OrderColumn": "",
    "OrderBy": 1
}, User.Token);
                    
                    // Fetch Books Count
                    // Matching BooksPage.js pattern
                    const booksRes = await getAllBooks({
    "PageSize": 6,
    "PageNumber": 0,
    "SearchValue": "",
    "OrderColumn": "",
    "OrderBy": 1
}, User.Token);

                    // Fetch Coaches Count
                    // Coaches.js uses 'jwtP' from sessionStorage (Admin Token)
                    const jwtP = sessionStorage.getItem("jwtP");
                    const coachesToken = jwtP || User.Token;
                    const coachesRes = await GetAllCoaches(coachesToken, true);

                    // Fetch Feedbacks Count
                    // params taken from FeedBacksPage.js defaults
                    const reportsParams = {
                      MonthCount: 3,
                      StatusType: 2, // All
                      OrderBy: 0
                    };
                    const feedbacksRes = await getReports(reportsParams, User.Token);

                    setStats({
                        totalUsers: usersRes && usersRes.data && usersRes.data.Users ? (usersRes.data.RowCount || 0) : 0,
                        totalBooks: booksRes && booksRes.data && booksRes.data.Books ? (booksRes.data.RowCount || 0) : 0,
                        totalCoaches: coachesRes && coachesRes.data && Array.isArray(coachesRes.data.ResponseData) ? coachesRes.data.ResponseData.length : 0,
                        totalFeedbacks: feedbacksRes && feedbacksRes.data && Array.isArray(feedbacksRes.data) ? feedbacksRes.data.length : 0
                    });

                } catch (e) {
                     console.error("Failed to fetch admin stats", e);
                }
             }
        };

        fetchStats();
    }, []);



    const menuItems = [
        { title: 'Members', path: '/members', icon: Members },
        { title: 'Work List', path: '/worklist', icon: WorkList },
        { title: 'Books', path: '/books', icon: BooksIcon },
        { title: 'FeedBacks', path: '/feedbacks', icon: Feedback },
        { title: 'Credits', path: '/usercredits', icon: Credit },
        { title: 'Ürün Atama', path: '/ProductAssignment', icon: ProductAssignment },
        { title: 'Cache', path: '/caches', icon: Cache },
        { title: 'Corporate', path: '/Corporate', icon: Corporate },
        { title: 'Canlı Ders Paneli', path: '/onlineLecturePanel', icon: OnlineLecture },
        { title: 'Content Management', path: '/contentManagment', icon: ContentManagment },
        { title: 'Application Logs', path: '/AppLogs', icon: Logs },
         { title: 'Coaches', path: '/CoachesAdminPanel', icon: Coaching },
         { title: 'Analytics Page', path: '/AnalyticsPage', icon: Analytics },
         { title: 'CMS Onaylama', path: '/NewQuestionApproveCoursePage', icon: CMSApprove },
         { title: 'CMS', path: '/NewTopicAndAchSelectionCoursePage', icon: CMS },
         { title: 'KPSS Soru Eşleştirme', path: '/KpssCompatibilityCourses', icon: KPSSComp },
         { title: 'Sorulara Kazanım Ekleme', path: '/AchievementCourses', icon: AchivementSelection },
         { title: 'Sorulara Konu Ekleme', path: '/questionSubTopicSelectionCoursePage', icon: TopicSelection },
         { title: 'Soru Video Çözüm Paneli', path: '/questionVideoSolution', icon: VideoSolution },
         { title: 'İnteraktif Video', path: '/VideoInteractionDashboard', icon: OnlineLecture },
    ];

    const statCards = [
        { label: 'Total Users', value: stats.totalUsers },
        { label: 'Total Books', value: stats.totalBooks },
        { label: 'Total Coaches', value: stats.totalCoaches },
        { label: 'Feedbacks', value: stats.totalFeedbacks },
    ];

    return (
        <div>
            <SideBar />
            <div style={{ 
                padding: 20, 
                marginLeft: Components.SideBarWidth + 15, // Adjusted for Sidebar
                marginRight: 30,
                paddingTop: 20
            }}>
            <Typography variant="h4" style={{ color: Primary.TextColor, marginBottom: 20 }}>
                Admin Dashboard
            </Typography>

            {/* Statistics Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                System Overview
            </Typography>
            <Grid container spacing={3} style={{ marginBottom: 30 }}>
                {statCards.map((stat, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                         <Card style={{ height: '100%', backgroundColor: Primary.Background }}>
                            <CardContent style={{ textAlign: 'center' }}>
                                <Typography variant="h3" style={{ color: Primary.TopBar }}>
                                    {stat.value}
                                </Typography>
                                <Typography variant="subtitle1" style={{ color: Primary.TextColor }}>
                                    {stat.label}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Menu Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                Management Modules
            </Typography>
            <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <Card 
                            style={{ cursor: 'pointer', height: '100%' }}
                            onClick={() => history.push(item.path)}
                        >
                            <CardContent style={{ textAlign: 'center' }}>
                                <img src={item.icon} alt={item.title} style={{ width: 50, height: 50, marginBottom: 10 }} />
                                <Typography variant="h6" component="h2">
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            </div>
        </div>
    );
};



const mapDispatchToProps = (dispatch) => ({
    setSelectedItem: (item) => dispatch(setSelectedItem(item))
});

export default connect(null, mapDispatchToProps)(AdminDashboard);
